import apiClient from './apiClient'

const FRONTEND_URL = process.env.REACT_APP_API_URL

/**
 * Starts Stripe Checkout for a PAID tier and redirects to the hosted checkout URL.
 * `tier` is the display name ("Pro", "Premium", "Star Light"); `monthly` toggles the period.
 * Identity comes from the access token, so no userId is sent. Throws on failure.
 */
export async function startCheckout(tier, monthly) {
    const { data } = await apiClient.post('/billing/checkout', { tier, monthly })
    window.location.href = data.url
}

/** Activates the free (Light) plan server-side (sets hasActiveTier). No Stripe involved. */
export async function activateFreeTier() {
    await apiClient.post('/billing/free')
}

/** Free (Light) tier needs no checkout — go to the studio (full reload picks up fresh user). */
export function goToStudioFree() {
    window.location.href = `${FRONTEND_URL}/studio`
}
